import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router';
import axios from 'axios';

import { SsoTokens } from '@/types/ssoTokens';
import { adminApi } from '@/services/api';
import i18n from '@/settings/i18n';
import { pages } from '@/settings/pages';
import { ProjectIdForGLSSSO } from '@/localStorage/ProjectIdForGLSSSO';
import { ProjectCodeForGLSSSO } from '@/localStorage/ProjectCodeForGLSSSO';
import { store } from '@/store';
import { useFlashMessenger } from '@/hooks/useFlashMessenger';
import { useApiErrorHandler } from '@/hooks/useApiErrorHandler';

import { AuthGateway } from '../Presentation';

export const AuthGatewayContainer: React.FC = () => {
  const { apiErrorHandler } = useApiErrorHandler();
  const { flashError } = useFlashMessenger();

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    (async () => {
      const params = new URLSearchParams(location.search);
      const gpc = params.get('gpc') || '';
      const gss = params.get('gss') || '';
      const glo = params.get('glo') || '';
      const gul = i18n.languages[0] === 'ja' ? 'ja' : 'en';

      if (!store.getState().auth.current.isLoggedIn && glo !== 'true') {
        window.location.assign(
          `${pages.signin.index}?returnTo=${encodeURIComponent(
            window.location.href,
          )}`,
        );
        return;
      }
      if (glo === 'true') {
        window.location.assign(pages.signout.index);
        return;
      }

      if (!gpc || !gss) {
        navigate(pages.top, { replace: true });
      } else {
        try {
          const ssoTokens = await adminApi.getSsoTokens({
            data: { gpc, gss, gul },
          });
          const currentOrganizationGloplaId =
            store.getState().auth.current.organization.gloplaId;
          const url = composeRedirectURL(
            ssoTokens,
            ProjectIdForGLSSSO.get,
            ProjectCodeForGLSSSO.get,
            currentOrganizationGloplaId,
          );
          window.location.assign(url);
        } catch (err) {
          const isNotAuthorized =
            axios.isAxiosError(err) &&
            err.response &&
            err.response.status === 403;
          if (isNotAuthorized) {
            flashError(i18n.t('ui.error.forbidden'));
          } else {
            apiErrorHandler(err);
          }
          navigate(pages.top, { replace: true });
        }
      }
    })();
  }, [apiErrorHandler, flashError, location.search, navigate]);

  return <AuthGateway />;
};

export const composeRedirectURL = (
  ssoTokens: SsoTokens,
  projectIdGetter: () => string | null,
  projectCodeGetter: () => string | null,
  currentOrganizationGloplaId: string,
) => {
  // TODO: プロダクト毎のIDを定数化する
  const isGLS = (productId: number) => productId === 4;
  const guq = ssoTokens.guq || '';
  const url = `${ssoTokens.authUrl}?guq=${guq}&gss=${ssoTokens.gss}&gui=${ssoTokens.gui}&gsg=${ssoTokens.gsg}&ghs=${ssoTokens.ghs}&gul=${ssoTokens.gul}&goi=${currentOrganizationGloplaId}`;

  if (isGLS(ssoTokens.productId)) {
    const selectedProjectId = projectIdGetter();
    const selectedProjectCode = projectCodeGetter();
    return `${url}&projectId=${selectedProjectId}&projectCode=${selectedProjectCode}`;
  }

  return url;
};
